module.exports = __webpack_public_path__ + "img/icon-plus-circle.228430dd.svg";